import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

if (pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else if (pdfFonts.vfs) {
  pdfMake.vfs = pdfFonts.vfs;
}


export const createFooter = () => {
  return {
    margin: [40, 0, 40, 0],
    columns: [
      {
        text: 'Generated by ClimateRX',
        style: 'footer',
        alignment: 'left'
      },
      {
        text: new Date().toLocaleDateString(),
        style: 'footer',
        alignment: 'right'
      }
    ]
  };
};

export const getDefaultStyles = () => {
  return {
    headerClientName: {
      fontSize: 12,
      bold: true,
      color: '#1a237e'
    },
    headerAccountInfo: {
      fontSize: 8,
      color: '#000000'
    },
    modernTableHeader: {
      fontSize: 7,
      bold: true,
      alignment: 'center',
      letterSpacing: 0.5
    },
    modernTableCell: {
      fontSize: 7,
      color: '#424242'
    },
    modernTableAmount: {
      fontSize: 7,
      bold: true,
      alignment: 'right'
    },
    tableBalance: {
      fontSize: 7,
      bold: true,
      alignment: 'right',
      color: '#000000'
    },
    modernTableNA: {
      fontSize: 6,
      color: '#9e9e9e',
      alignment: 'center',
      italics: true
    },
    footer: {
      fontSize: 7,
      color: '#7f8c8d'
    },
    receiptDateHeader: {
      fontSize: 10,
      bold: true,
      color: '#007bff',
      margin: [0, 5, 0, 5]
    },
    receiptNotAvailable: {
      fontSize: 11,
      color: '#6c757d',
      italics: true
    },
    receiptFooter: {
      fontSize: 8,
      color: '#6c757d',
      italics: true
    }
  };
};

